export const BRANDS = {
  xpro: {
    key: "xpro",
    name: "Xpro",
    title: "Xpro",
    website: "https://www.xvisiontecnologia.com.br",
    domainMatch: (host) => host.endsWith("xpro.me"),

    assets: {
      basePath: "/brands/xpro",
      logo: {
        light: "/brands/xpro/logo.png",
        dark: "/brands/xpro/logowhite.png",
      },
      favicon: "/brands/xpro/favicon.png",
      appleTouchIcon: "/brands/xpro/apple-touch-icon.png",
      manifest: "/brands/xpro/manifest.json",
    },
  },

  y21: {
    key: "y21",
    name: "Y21",
    title: "Y21",
    website: "https://www.y21.pro",
    domainMatch: (host) => host.endsWith("y21.pro"),

    assets: {
      basePath: "/brands/y21",
      logo: {
        light: "/brands/y21/logo.png",
        dark: "/brands/y21/logowhite.png",
      },
      favicon: "/brands/y21/favicon.png",
      appleTouchIcon: "/brands/y21/apple-touch-icon.png",
      manifest: "/brands/y21/manifest.json",
    },
  },
};

export function resolveBrand(hostname = window.location.hostname) {
  const host = hostname.toLowerCase();
  // console.log("Resolvendo brand para host:", host, Object.values(BRANDS).find((b) => b.domainMatch(host)) ||
    // BRANDS.xpro);
  return (
    Object.values(BRANDS).find((b) => b.domainMatch(host)) ||
    BRANDS.xpro
  );
}
